import React from 'react';

import {ProcessesFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {
  ActionMethod,
  ActionOrigin,
  ProcessPlatformFeatureType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ProcessTaskStatus} from 'processes/__generated/ProcessTaskStatus';
import {getProcessPlatformFeatureConfig} from 'processes/processes-platform/FeatureOptions';
import TaskStatusEditor from 'processes/status/TaskStatusEditor';
import submitTasksWithConfirmation from 'processes/tables/submitTasksWithConfirmation';
import {readableTime} from 'util/DateUtil';

import {ProcessTaskFieldProps} from '../ProcessTaskDetailsPageConstants';

export default function StatusField({processTask, onUpdateTask}: ProcessTaskFieldProps): JSX.Element {
  return (
    <TaskStatusEditor
      status={processTask.status}
      statusLifecycle={processTask.schema.statusLifecycle}
      lastUpdated={readableTime(processTask.lastStatusChange.createdAt)}
      onSelect={async (selectedStatus: ProcessTaskStatus) => {
        await submitTasksWithConfirmation({
          taskSchemaId: processTask.schema.id,
          tasks: [
            {
              id: processTask.id,
              statusId: selectedStatus.id,
              oldStatusId: processTask.status.id,
              sourceType: 'task_details',
              actionOrigin: ActionOrigin.WORKFLOWS_TASK_DETAILS_PAGE,
              actionMethod: ActionMethod.BUTTON_CLICK,
            },
          ],
          onRequestSubmit: async () => {
            await onUpdateTask({
              id: processTask.id,
              statusId: selectedStatus.id,
            });
          },
        });
      }}
      disabled={
        !getProcessPlatformFeatureConfig(
          ProcessPlatformFeatureType.CAN_EDIT_STATUS_FROM_UI,
          processTask.schema.executionType,
          processTask.schema.name
        ) || !isFeatureEnabled({feature: ProcessesFeature.PROCESSES_EDIT, item: processTask})
      }
    />
  );
}
